import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV130({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.3.0" date="8th June 2025" title="New Tools and Club Content!">
      <p className="text-gray-300 mb-4">We've rolled out a whole new tools menu option where we will add a list of useful tools that make your life easier.</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Added club content management component', '/v1.3.0/content.jpg')}
        {createClickableListItem('Added new tools section', '/v1.3.0/tools.jpg')}
        {createClickableListItem('Pot Split calculator', '/v1.3.0/calculator.jpg')}
        <li>• Bug fix: Fixed photo upload issue</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.3.0/content.jpg', 'Club content management component feature preview')}
          {createThumbnail('/v1.3.0/tools.jpg', 'Pot Split utility feature preview')}
          {createThumbnail('/v1.3.0/calculator.jpg', 'Pot Split calculator feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Thanks for all your support, we're building this together!</p>
    </ReleaseCard>
  );
}
